import Head from "../../elements/head/head";
import Footer from "../../elements/footer/footer";
import "./record.scss";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import FixedBottomNavigation from "../../elements/navigation/navigation";
import { API_MEDIA } from "../../env";
import api from "../../api";
import { useSelector } from "react-redux";
import Progress from "../../elements/progress/progress";
import AccordionUsage from "./accordeon";

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Paper_ = styled(Paper)(({ theme }) => ({
  width: "100%",
  margin: 3,
}));

const Record = (args) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const search = useSelector((state) => state.searchSelector.search);
  const countRef = useRef(0);
  const [totalTimeSpent, setTotalTimeSpent] = useState(null);

  const getRecordFunc = () => {
    setLoading(true);
    api.getRecord(search).then((response) => {
      console.log(search);
      setData(response.data.record);
    });
    setLoading(false);
  };

  useEffect(() => {
    getRecordFunc(search);
  }, [search]);

  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid
          size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}
          spacing={1}
          container
          direction="rows"
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper_>
            {data.length != 0 ? (
              data.map((column) => <AccordionUsage data={column} />)
            ) : (
              <h3>
                {" "}
                Вас приветствует Рязанская Федерация пауэрлифтинга! Тут пока нет
                ни одного документа!
              </h3>
            )}
          </Paper_>
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
        }}
        size={{ lg: 1, xl: 1 }}
      ></Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Record;
